import { BreakpointObserver, LayoutModule } from '@angular/cdk/layout';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { Subscription } from 'rxjs';
import { MaterialModule } from 'src/app/material.module';
import { AuthService } from 'src/app/services/auth.service';
import { StorageService } from 'src/app/services/storage.service';
import { HeaderComponent } from '../../full/header/header.component';
import { AppNavItemComponent } from '../../full/sidebar/nav-item/nav-item.component';
import { SidebarComponent } from '../../full/sidebar/sidebar.component';

const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';
const BELOWMONITOR = 'screen and (max-width: 1023px)';

@Component({
  selector: 'app-without-sidebar',
  standalone: true,
  imports: [
    RouterModule,
    AppNavItemComponent,
    MaterialModule,
    CommonModule,
    SidebarComponent,
    LayoutModule,
    NgScrollbarModule,
    TablerIconsModule,
    HeaderComponent,
  ],
  templateUrl: './without-sidebar.component.html',
  styleUrl: './without-sidebar.component.scss'
})
export class WithoutSidebarComponent implements OnInit {


  //get options from service
  private layoutChangesSubscription = Subscription.EMPTY;
  private isMobileScreen = false;
  private htmlElement!: HTMLHtmlElement;

  get isOver(): boolean {
    return false;
  }

  constructor(
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private storageService: StorageService,
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: Object) {

    if (isPlatformBrowser(this.platformId)) {
      this.htmlElement = document.querySelector('html')!;
      this.htmlElement.classList.add('light-theme');
      this.layoutChangesSubscription = this.breakpointObserver
        .observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW])
        .subscribe((state) => {
          // SidenavOpened must be reset true when layout changes
          this.isMobileScreen = state.breakpoints[MOBILE_VIEW];
        });
    }
  }

  disableHeaderLink = false;

  ngOnInit(): void {
    // Check initial url
    this.checkIfHeaderLinkShouldBeDisabled();

    // Subscribe to router events to keep it updated
    this.router.events.subscribe(() => {
      this.checkIfHeaderLinkShouldBeDisabled();
    });
  }

  checkIfHeaderLinkShouldBeDisabled() {
    this.disableHeaderLink = this.router.url.includes('beneficios-only');
  }


  ngOnDestroy() {
    this.layoutChangesSubscription.unsubscribe();
  }

}
